import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseLike: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5607 13.0607L13.0607 20.5607C12.4749 21.1465 11.5251 21.1465 10.9393 20.5607L3.43934 13.0607C1.47284 11.0942 1.47284 7.90585 3.43934 5.93935C5.40583 3.97285 8.59416 3.97285 10.5607 5.93935L12 7.37869L13.4393 5.93935C15.4058 3.97286 18.5942 3.97285 20.5607 5.93935C22.5272 7.90585 22.5272 11.0942 20.5607 13.0607ZM12 9.50001L9.5 7.00001C8.11928 5.6193 5.88071 5.6193 4.5 7.00001C3.11928 8.38072 3.11928 10.6193 4.5 12L12 19.5L19.5 12C20.8807 10.6193 20.8807 8.38072 19.5 7.00001C18.1193 5.6193 15.8807 5.6193 14.5 7.00001L12 9.50001Z"
        fill={color}
      />
    </svg>
  );
};
